export default __webpack_public_path__ + "static/avatar-2-1d9a4811f397bbf337fb898a2df9fec5.png";